(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["phonecbd-contact-intents"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
  const link = event.target.closest('[data-pcb-contact-intent]');
  if (!link) return;
  const form = document.getElementById('ContactPageForm');
  const select = form?.querySelector('select[name="contact[Objet]"]');
  if (select && [...select.options].some(option => option.value === link.dataset.pcbContactIntent)) {
    select.value = link.dataset.pcbContactIntent;
    select.dispatchEvent(new Event('change', {bubbles:true}));
  }
  form?.querySelector('input:not([type="hidden"])')?.focus({preventScroll:true});
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["phonecbd-repair-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.PCBRepair) return;
  const memory = new Map();
  const pending = new Map();
  const ttl = 10 * 60 * 1000;
  const text = key => document.getElementById('pcb-repair-config')?.dataset[key] || '';
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\+/g, 'plus').replace(/[^a-z0-9]/g, '');
  const matches = (label, query) => normalize(label).includes(normalize(query));
  const sameOrigin = value => {
    const url = new URL(value, location.origin);
    if (url.origin !== location.origin) throw new Error('External repair route');
    return url;
  };
  const preview = url => {
    const current = new URL(location.href);
    for (const key of ['preview_theme_id', '_fd', 'pb']) {
      if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
    }
    return url;
  };
  const request = async (url, json = true) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(preview(sameOrigin(url)), {credentials: 'same-origin', signal: controller.signal});
      if (!response.ok) throw new Error('Repair catalogue unavailable');
      return json ? await response.json() : await response.text();
    } finally { clearTimeout(timer); }
  };
  async function cached(key, loader) {
    const cacheKey = 'pcb-repair-v1317-2:' + location.host + ':' + (window.Shopify?.theme?.id || '') + ':' + key;
    let record = memory.get(cacheKey);
    if (!record) {
      try { record = JSON.parse(sessionStorage.getItem(cacheKey)); } catch (_) {}
    }
    if (record && Date.now() - record.time < ttl && Array.isArray(record.items)) return record.items;
    if (pending.has(cacheKey)) return pending.get(cacheKey);
    const promise = loader().then(items => {
      const value = {time: Date.now(), items};
      memory.set(cacheKey, value);
      try { sessionStorage.setItem(cacheKey, JSON.stringify(value)); } catch (_) {}
      return items;
    }).finally(() => pending.delete(cacheKey));
    pending.set(cacheKey, promise);
    return promise;
  }
  function groupModels(items) {
    const result = [];
    const urls = new Set();
    for (const item of items) {
      if (!item?.url || !item.title) continue;
      const url = sameOrigin(item.url);
      if (!url.pathname.includes('/products/') || urls.has(url.pathname)) continue;
      urls.add(url.pathname);
      const ref = item.title.match(/\bA\d{4}\b/i)?.[0];
      const key = ref ? normalize(item.title.replace(/macbook|réparation|reparation|pouces|inch/gi, '')) : '';
      const found = key ? result.findIndex(other => other.key === key) : -1;
      if (found >= 0) {
        const existing = result[found].item;
        if (!existing.services || !item.services || existing.signature === item.signature) {
          if (item.services > existing.services) result[found].item = item;
          continue;
        }
      }
      result.push({key, item});
    }
    return result.map(entry => entry.item);
  }
  const loadModels = collectionUrl => cached('models:' + collectionUrl, async () => {
    const url = sameOrigin(collectionUrl);
    if (!/\/collections\/[^/]+\/?$/.test(url.pathname)) throw new Error('Invalid collection');
    url.searchParams.set('view', 'pcb-model-index');
    url.searchParams.set('page', '1');
    const first = await request(url);
    const valid = payload => payload?.version === 1 && Array.isArray(payload.items) && Number.isInteger(payload.pages) && payload.pages <= 100;
    if (!valid(first)) throw new Error('Invalid repair index');
    const items = first.items.slice();
    const deadline = Date.now() + 16000;
    for (let page = 2; page <= first.pages; page++) {
      if (Date.now() > deadline) throw new Error('Repair index time limit');
      url.searchParams.set('page', String(page));
      const payload = await request(url);
      if (!valid(payload) || payload.page !== page) throw new Error('Incomplete repair index');
      items.push(...payload.items);
    }
    const grouped = groupModels(items);
    if (typeof first.collection === 'string') {
      const canonical = sameOrigin(first.collection).pathname;
      const cacheKey = 'pcb-repair-v1317-2:' + location.host + ':' + (window.Shopify?.theme?.id || '') + ':models:' + canonical;
      const record = {time: Date.now(), items: grouped};
      memory.set(cacheKey, record);
      try { sessionStorage.setItem(cacheKey, JSON.stringify(record)); } catch (_) {}
    }
    return grouped;
  });
  const loadBrands = pageUrl => cached('brands:' + pageUrl, async () => {
    const html = await request(pageUrl, false);
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const seen = new Set();
    const items = Array.from(doc.querySelectorAll('[data-brand-list] [data-brand]')).flatMap(node => {
      const anchor = node.querySelector('a[href]');
      if (!anchor) return [];
      const url = sameOrigin(anchor.getAttribute('href'));
      const match = url.pathname.match(/\/collections\/([^/]+)/);
      const label = node.dataset.brand;
      if (!label || seen.has(normalize(label))) return [];
      seen.add(normalize(label));
      return [{label, url: url.pathname, collection: match?.[1] || ''}];
    });
    if (!items.length) throw new Error('Brands unavailable');
    return items;
  });
  function whatsapp(message) {
    let number = text('whatsapp').replace(/\D/g, '');
    if (number.startsWith('00')) number = number.slice(2);
    if (/^0\d{9}$/.test(number)) number = '33' + number.slice(1);
    if (!/^\d{8,15}$/.test(number)) number = '33759957654';
    const url = new URL('https://wa.me/' + number);
    if (message) url.searchParams.set('text', message);
    return url.href;
  }
  function updateLink(anchor) {
    if (!anchor) return;
    try {
      const url = new URL(anchor.href);
      if (!['wa.me', 'api.whatsapp.com', 'web.whatsapp.com'].includes(url.hostname)) return;
      const next = whatsapp(url.searchParams.get('text'));
      if (anchor.href !== next) anchor.href = next;
    } catch (_) {}
  }
  function refreshContacts() {
    document.querySelectorAll('a[href*="wa.me"],a[href*="whatsapp.com"]').forEach(updateLink);
  }
  document.addEventListener('click', event => updateLink(event.target.closest?.('a[href]')), true);
  document.addEventListener('shopify:section:load', refreshContacts);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refreshContacts, {once: true});
  else refreshContacts();
  window.PCBRepair = {normalize, matches, groupModels, loadModels, loadBrands, whatsapp, text};
  document.dispatchEvent(new Event('pcb:repair-ready'));
})();
  } catch(e) { console.error(e); }
})();

})();
